import {Avatar, Box, Chip} from '@mui/material';
import NorthEastRoundedIcon from '@mui/icons-material/NorthEastRounded';

export const statusOptions = [
  {value: '', label: 'Tümü'},
  {value: 'open', label: 'Açık'},
  {value: 'in_progress', label: 'İşleniyor'},
  {value: 'resolved', label: 'Çözüldü'},
  {value: 'closed', label: 'Kapatıldı'},
];

const statusColors = {
  open: {color: '#2563eb', background: '#eff6ff'},
  in_progress: {color: '#a16207', background: '#fffbeb'},
  resolved: {color: '#15803d', background: '#f0fdf4'},
  closed: {color: '#64748b', background: '#f1f5f9'},
};

export const getTicketDraft = ticket => ({
  status: ticket.status,
  adminNote: ticket.meta?.adminNote || '',
  adminReply: ticket.meta?.adminReply || '',
});

export function formatTicketDate(value, includeTime = false) {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return 'Tarih belirtilmedi';
  return date.toLocaleString('tr-TR', {
    day: '2-digit', month: 'short', year: 'numeric',
    ...(includeTime ? {hour: '2-digit', minute: '2-digit'} : {}),
  });
}

export function TicketAvatar({name = '', size = 36}) {
  const colors = [
    {bg: '#eef2ff', fg: '#6366b6'},
    {bg: '#ecfdf5', fg: '#34856c'},
    {bg: '#fff7ed', fg: '#b67839'},
    {bg: '#fdf2f8', fg: '#b5608d'},
  ];
  const color = colors[Array.from(name).reduce((sum, char) => sum + char.charCodeAt(0), 0) % colors.length];
  const initials = name.trim().split(/\s+/).slice(0, 2).map(word => word[0]).join('').toLocaleUpperCase('tr-TR');
  return <Avatar aria-hidden="true" sx={{width: size, height: size, bgcolor: color.bg, color: color.fg, fontSize: 12, fontWeight: 700}}>{initials || '?'}</Avatar>;
}

export function TicketStatus({status}) {
  const style = statusColors[status] || statusColors.closed;
  return (
    <Chip size="small" label={statusOptions.find(option => option.value === status)?.label || status}
      icon={<Box component="span" sx={{width: 6, height: 6, borderRadius: '50%', bgcolor: style.color}} />}
      sx={{height: 27, fontSize: 12, fontWeight: 600, borderRadius: '7px', bgcolor: style.background, color: style.color, '& .MuiChip-icon': {ml: '9px'}, '& .MuiChip-label': {px: '9px'}}} />
  );
}

export function TicketPriority({priority}) {
  const high = priority === 'high';
  return (
    <Chip size="small" label={high ? 'Yüksek' : 'Normal'}
      icon={high ? <NorthEastRoundedIcon /> : undefined}
      sx={{height: 27, fontSize: 12, fontWeight: 600, borderRadius: '7px', bgcolor: high ? '#fff1f2' : '#f8fafc', color: high ? '#be4356' : '#64748b', '& .MuiChip-icon': {color: 'inherit', fontSize: 14}, '& .MuiChip-label': {px: '9px'}}} />
  );
}
